export default __webpack_public_path__ + "static/media/Sparks.affc8f77.png";